import { Input, Button, Space, Select, DatePicker, Row, Col } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import CustomNumber from "components/CustomNumber";
import dayjs from "dayjs";
import SelectWithEndpoint from "components/CustomTable/selectWithEndpoint";

const { Option } = Select;
const { RangePicker } = DatePicker;

const getColumnSearchProps = ({ type = "input", dtSrc = [], endpoint, value }) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    return (
      <div style={{ padding: 8 }}>
        {type === "input" ? (
          <Input
            placeholder={`Хайх ...`}
            value={selectedKeys[0] ?? []}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value.trim()] : [])}
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
        ) : type === "number" ? (
          <CustomNumber
            placeholder={`Хайх ...`}
            value={selectedKeys[0] ?? [value]}
            onChange={(value) => setSelectedKeys(value ? [value] : value === 0 ? [0] : [])}
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
        ) : type === "select" ? (
          <Select
            placeholder="Сонгоно уу"
            value={selectedKeys[0] ?? [value]}
            onChange={(e) => {
              setSelectedKeys([e]);
            }}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          >
            {dtSrc.map((data) => (
              <Option key={data.val} value={data.val}>{`${data.txt}`}</Option>
            ))}
          </Select>
        ) : type === "selectEndpoint" ? (
          <SelectWithEndpoint
            placeholder="Сонгоно уу"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys([e]);
            }}
            style={{ width: 188, marginBottom: 8, display: "block" }}
            endpoint={endpoint}
          />
        ) : type === "date" ? (
          <DatePicker
            placeholder="Огноо сонгоно уу"
            style={{ width: "100%", marginBottom: 8, display: "block" }}
            onChange={(dates) => setSelectedKeys(dates)}
            onPressEnter={() => confirm()}
          />
        ) : type === "rngdate" ? (
          <RangePicker
            style={{ width: 250, marginBottom: 8, display: "flex" }}
            ranges={{
              Өнөөдөр: [dayjs(), dayjs()],
              "Энэ сар": [dayjs().startOf("month"), dayjs().endOf("month")],
            }}
            onChange={(_, dates) => setSelectedKeys(dates)}
            onPressEnter={() => confirm()}
          />
        ) : type === "rngtransdate" ? (
          <RangePicker
            style={{ width: 250, marginBottom: 8, display: "flex" }}
            ranges={{
              Өнөөдөр: [dayjs(), dayjs()],
              "Энэ сар": [dayjs().startOf("month"), dayjs().endOf("month")],
            }}
            onChange={(_, dates) => setSelectedKeys(dates)}
            onPressEnter={() => confirm()}
          />
        ) : type === "rngnumber" ? (
          <Row gutter={8}>
            <Col span={12}>
              <Input
                placeholder={`Бага утга`}
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value, selectedKeys[1]] : [])}
                style={{ width: 91, marginBottom: 8, display: "block" }}
              />
            </Col>
            <Col span={12}>
              <Input
                placeholder={`Их утга`}
                value={selectedKeys[1]}
                onChange={(e) => setSelectedKeys(e.target.value ? [selectedKeys[0], e.target.value] : [])}
                onPressEnter={() => confirm()}
                style={{ width: 91, marginBottom: 8, display: "block" }}
              />
            </Col>
          </Row>
        ) : null}

        <Space>
          <Button type="primary" onClick={() => confirm()} icon={<SearchOutlined />} size="small" style={{ width: 90 }}>
            Хайх
          </Button>
          <Button
            onClick={async () => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: 90 }}
          >
            Арилгах
          </Button>
        </Space>
      </div>
    );
  },
  filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />,
  onFilter: () => true,
});

export default getColumnSearchProps;
